import { render } from "./CardResolucoes.vue?vue&type=template&id=8aafcada"
import script from "./CardResolucoes.vue?vue&type=script&lang=js"
export * from "./CardResolucoes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__